import { SETTINGS } from "../lib/constants/actions";
export const setting = (state = {}, action) => {
    switch (action.type) {
        case SETTINGS.GET_SETTING_SUCCESS:
            return { ...state, settingData: action.payload }
        case SETTINGS.SAVE_SETTING_SUCCESS:
            return { ...state, settingSaved: action.payload }
        case SETTINGS.SAVE_APP_VERSION_SETTING_SUCCESS:
            return { ...state, versionSettingSaved: action.payload }
        case SETTINGS.GET_APP_VERSION_SETTING_SUCCESS:
            return { ...state, versionSetting: action.payload }
        default:
            return state;
    }
};




